interface QuickPromptCardsProps {
  prompts: Array<string>
  onSelect: (prompt: string) => void
  testId?: string
  className?: string
}

export function QuickPromptCards({
  prompts,
  onSelect,
  testId = 'quick-prompt-card',
  className,
}: QuickPromptCardsProps) {
  return (
    <div className={className ?? 'grid gap-2 sm:grid-cols-3 sm:gap-3'}>
      {prompts.map((prompt) => (
        <button
          key={prompt}
          type="button"
          data-testid={testId}
          className="rounded-xl border border-border/70 bg-card px-4 py-3 text-left text-[15px] font-medium leading-5 text-foreground shadow-none transition-all hover:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:min-h-[92px] sm:rounded-2xl sm:border-border/80 sm:px-4 sm:py-4 sm:text-sm sm:leading-6 sm:shadow-sm sm:hover:-translate-y-0.5 sm:hover:shadow-md"
          onClick={() => onSelect(prompt)}
        >
          {prompt}
        </button>
      ))}
    </div>
  )
}
